import { create } from 'zustand';

interface PropDialogStore {
  dialogs: Record<string, boolean>;
  show: (name: string) => void;
  hide: (name: string) => void;
  toggle: (name: string) => void;
  isOpen: (name: string) => boolean;
}

const DialogStore = create<PropDialogStore>((set, get) => ({
  dialogs: {},
  show: name => set(state => ({ dialogs: { ...state.dialogs, [name]: true } })),
  hide: name => set(state => ({ dialogs: { ...state.dialogs, [name]: false } })),
  toggle: name => set(state => ({ dialogs: { ...state.dialogs, [name]: !state.dialogs[name] } })),
  isOpen: name => get().dialogs[name] || false,
}));

export default DialogStore;
